import React, { useState } from 'react';
import { TiptapWithRxDB } from '../components/TiptapWithRxDB';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

/**
 * Демонстрационная страница для редактора с автосохранением
 */
export const EditorDemoPage: React.FC = () => {
  const [documentId, setDocumentId] = useState('demo-document-1');
  
  const handleDocumentChange = (id: string) => {
    setDocumentId(id);
  };
  
  useDocumentTitle('Демо редактора');
  
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Редактор с автосохранением (RxDB)</h1>
      
      <div className="mb-6">
        <h2 className="text-lg font-semibold mb-2">Выберите документ:</h2>
        <div className="flex space-x-4">
          <button 
            className={`px-4 py-2 rounded ${documentId === 'demo-document-1' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
            onClick={() => handleDocumentChange('demo-document-1')}
          >
            Документ 1
          </button>
          <button 
            className={`px-4 py-2 rounded ${documentId === 'demo-document-2' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
            onClick={() => handleDocumentChange('demo-document-2')}
          >
            Документ 2
          </button>
          <button 
            className={`px-4 py-2 rounded ${documentId === 'demo-document-3' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
            onClick={() => handleDocumentChange('demo-document-3')}
          >
            Документ 3
          </button>
        </div>
      </div>
      
      <div className="border-t pt-4">
        <h2 className="text-lg font-semibold mb-4">
          Редактирование документа: {documentId}
        </h2>
        
        <TiptapWithRxDB
          documentId={documentId}
          className="min-h-[400px]"
          autoSaveDelay={300}
          syncDelay={2000}
        />
        
        <div className="mt-4 text-sm text-gray-500">
          <p>Информация о автосохранении:</p>
          <ul className="list-disc pl-5">
            <li>Автосохранение локально происходит через 300 мс после последнего изменения</li>
            <li>Синхронизация с сервером происходит через 2 секунды после локального сохранения</li>
            <li>Ctrl+S или Cmd+S для принудительного сохранения и синхронизации</li>
            <li>При переключении между документами состояние сохраняется</li>
            <li>При закрытии страницы несохраненные изменения отправляются на сервер</li>
            <li>База данных RxDB в IndexedDB сохраняет до 15 последних документов по алгоритму LRU</li>
          </ul>
        </div>
      </div>
    </div>
  );
}; 